const sentryConfig = window.__STOREFRONT_SENTRY__;

function getSentryEnvelopeUrl(dsn) {
  try {
    const parsedDsn = new URL(dsn);
    const projectId = parsedDsn.pathname.replace(/^\/+/, "").split("/").pop();
    if (!projectId || !parsedDsn.username) {
      return null;
    }
    const sentryKey = encodeURIComponent(parsedDsn.username);
    return `${parsedDsn.protocol}//${parsedDsn.host}/api/${projectId}/envelope/?sentry_version=7&sentry_key=${sentryKey}&sentry_client=storefront-js`;
  } catch (error) {
    return null;
  }
}

function randomHex(length) {
  const fallbackHex = () =>
    Array.from({ length }, () =>
      Math.floor(Math.random() * 16).toString(16)
    ).join("");

  if (!window.crypto || !window.crypto.getRandomValues) {
    return fallbackHex();
  }

  const bytes = new Uint8Array(Math.ceil(length / 2));
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"))
    .join("")
    .slice(0, length);
}

function eventFromError(errorInfo, defaults) {
  const error = errorInfo && errorInfo.error;
  const message = error
    ? error.message
    : errorInfo && errorInfo.message
    ? errorInfo.message
    : "Unknown storefront error";
  const type = error && error.name ? error.name : "Error";

  const exception = { type, value: message };
  if (error && error.stack) {
    exception.stacktrace = {
      frames: [
        {
          filename: "stack",
          function: "<unknown>",
          lineno: 0,
          colno: 0,
          context_line: String(error.stack).slice(0, 5000),
        },
      ],
    };
  }

  return {
    ...defaults,
    message,
    culprit:
      errorInfo && errorInfo.filename
        ? errorInfo.filename
        : window.location.href,
    exception: {
      values: [exception],
    },
  };
}

function eventFromRejection(rejection, defaults) {
  const reason = rejection && rejection.reason;
  const message =
    reason && reason.message
      ? reason.message
      : String(reason || "Unhandled promise rejection");
  const type = reason && reason.name ? reason.name : "UnhandledRejection";

  const exception = { type, value: message };
  if (reason && reason.stack) {
    exception.stacktrace = {
      frames: [
        {
          filename: "stack",
          function: "<unknown>",
          lineno: 0,
          colno: 0,
          context_line: String(reason.stack).slice(0, 5000),
        },
      ],
    };
  }

  return {
    ...defaults,
    message,
    exception: {
      values: [exception],
    },
  };
}

if (
  sentryConfig &&
  sentryConfig.dsn &&
  !window.__STOREFRONT_SENTRY_INITIALIZED__
) {
  const sentryEnvelopeUrl = getSentryEnvelopeUrl(sentryConfig.dsn);
  if (sentryEnvelopeUrl) {
    window.__STOREFRONT_SENTRY_INITIALIZED__ = true;

    const sendToSentry = (eventPayload) => {
      const envelopeHeaders = {
        event_id: eventPayload.event_id,
        sent_at: new Date().toISOString(),
        sdk: {
          name: "storefront-js",
          version: "1.0.0",
        },
      };
      const itemHeaders = { type: "event" };
      const envelope = `${JSON.stringify(envelopeHeaders)}\n${JSON.stringify(
        itemHeaders
      )}\n${JSON.stringify(eventPayload)}`;

      if (navigator.sendBeacon) {
        const didQueue = navigator.sendBeacon(
          sentryEnvelopeUrl,
          new Blob([envelope], { type: "text/plain;charset=UTF-8" })
        );
        if (didQueue) {
          return;
        }
      }

      fetch(sentryEnvelopeUrl, {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=UTF-8" },
        body: envelope,
        keepalive: true,
        mode: "cors",
      }).catch(() => {});
    };

    const baseEvent = () => ({
      event_id: randomHex(32),
      timestamp: new Date().toISOString(),
      level: "error",
      logger: "storefront.javascript",
      platform: "javascript",
      user: {
        ip_address: null,
      },
      tags: {
        app: "storefront",
      },
      request: {
        url: window.location.href,
      },
    });

    window.addEventListener("error", (errorInfo) => {
      try {
        sendToSentry(eventFromError(errorInfo, baseEvent()));
      } catch (error) {}
    });

    window.addEventListener("unhandledrejection", (rejection) => {
      try {
        sendToSentry(eventFromRejection(rejection, baseEvent()));
      } catch (error) {}
    });
  }
}
